import { ElementRef, HostListener, Renderer2 } from '@angular/core';

export class SlValueAccessor<T> {
  constructor(protected element: ElementRef<T>, protected renderer: Renderer2, private propertyName: string) {
    this.onChange = () => { };
    this.onTouched = () => {}
  }

  onChange: (value: string | boolean) => void;
  onTouched: () => void;

  writeValue(value: string) {
    this.renderer.setProperty(this.element.nativeElement, this.propertyName, value);
  }

  handleValueChange(event: CustomEvent) {
    let value = event.detail;
    event.stopPropagation();
    this.onChange(value);
  }

  registerOnChange(fn: (value: string | boolean) => void) {
    this.onChange = value => {
      fn(value);
    };
  }

  registerOnTouched(fn: () => void) { 
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.renderer.setProperty(this.element.nativeElement, 'disabled', isDisabled);
  }

}